import Vue from "vue";
import Router from "vue-router";
import Index from "@/views/index";
import { title } from "echarts/lib/theme/dark";

Vue.use(Router);

export const RouterMap = [
  {
    path: "/",
    name: "index",
    component: Index,
    redirect: "/Home",
    children: [
      {
        path: "Home",
        name: "Home",
        meta: {
          title: "54741234热线平台"
        },
        component: () => import("@/views/Home/index.vue")
      },
      {
        path: "HistoryFeedback",
        name: "HistoryFeedback",
        component: () => import("@/views/HistoryFeedback/index.vue")
      },
      {
        path: "Evaluate",
        name: "Evaluate",
        component: () => import("@/views/Evaluate/index.vue")
      },
      {
        path: "ServiceType",
        name: "ServiceType",
        component: () => import("@/views/ServiceType/index.vue")
      },
      {
        path: "Bulletin",
        name: "Bulletin",
        component: () => import("@/views/Bulletin/index.vue")
      },
      {
        path: "BulletinArticle",
        name: "BulletinArticle",
        component: () => import("@/views/BulletinArticle/index.vue")
      },
      {
        path: "ViewFeedback",
        name: "ViewFeedback",
        component: () => import("@/views/ViewFeedback/index.vue")
      },
      {
        path: "Snapshot",
        name: "Snapshot",
        component: () => import("@/views/Snapshot/index.vue")
      },
      {
        path: "ServicePublic",
        name: "ServicePublic",
        component: () => import("@/views/ServicePublic/index.vue")
      },
      {
        path: "YouthVoice",
        name: "YouthVoice",
        component: () => import("@/views/YouthVoice/index.vue")
      },
      {
        path: "Gradute",
        name: "Gradute",
        component: () => import("@/views/Gradute/index.vue")
      },
      {
        path: "ServiceDetail",
        name: "ServiceDetail",
        component: () => import("@/views/ServicePublic/detail.vue")
      },
      {
        path: "DataPublic",
        name: "DataPublic",
        component: () => import("@/views/DataPublic/index.vue")
      },
      {
        path: "Dean",
        name: "Dean",
        component: () => import("@/views/Dean/index.vue")
      },
      {
        path: "TeamList",
        name: "TeamList",
        component: () => import("@/views/TeamList/index.vue")
        // redirect: '/TeamList/ItemDetail',
        // children:[
        //   {
        //     path: 'ItemDetail',
        //     name: 'ItemDetail',
        //     component: ()=>import('@/views/TeamList/ItemDetail')
        //   },
        // ]
      },
      {
        path: "Online",
        name: "Online",
        component: () => import("@/views/Online/index.vue")
      },
      {
        path: "Building",
        name: "Building",
        component: () => import("@/views/Building/building.vue")
      },
      {
        path: "/LostFind",
        name: "LostFind",
        component: () => import("@/views/LostFind/index.vue")
      },
      {
        path: "/waitClaim",
        name: "waitClaim",
        component: () => import("@/views/LostFind/waitClaim.vue")
      },
      {
        path: "/findThing",
        name: "findThing",
        component: () => import("@/views/LostFind/findThing.vue")
      },
      {
        path: "/minePublishInfo",
        name: "minePublishInfo",
        component: () => import("@/views/LostFind/minePublishInfo.vue")
      },
      {
        path: "/findInfo",
        name: "findInfo",
        component: () => import("@/views/LostFind/findInfo.vue")
      },
      {
        path: "/lostInfo",
        name: "lostInfo",
        component: () => import("@/views/LostFind/lostInfo.vue")
      },
      {
        path: "/addWaitClaim",
        name: "addWaitClaim",
        component: () => import("@/views/LostFind/addWaitClaim.vue")
      },
      {
        path: "/addFindThing",
        name: "addFindThing",
        component: () => import("@/views/LostFind/addFindThing.vue")
      }
    ]
  },
  {
    path: "/ShowData",
    name: "ShowData",
    component: () => import("@/views/ShowData/index.vue")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  base: __dirname,
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: RouterMap
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;

// export default new Router({
//   mode: 'history',
//   linkActiveClass:'active',
//   base: __dirname,
//   scrollBehavior: function (to, from, savedPosition) {
//     return savedPosition || { x: 0, y: 0 }
//   },
//   routes: RouterMap
// })

// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js